const PluginManagerHeader = () => {
    return (
        <thead>
            <tr>
                <th width="1%">#</th>
                <th style={{ width: '34%' }}>Plugin Name</th>
                <th style={{ width: '30%' }}>Default Version</th>
                <th style={{ width: '24%' }}>Default Version Description</th>
                <th className="text-center" style={{ width: '10%' }}></th>
            </tr>
        </thead>
    );
};

export default PluginManagerHeader;
